var map = {
	"./noble01/气泡框@2x.png": "7084",
	"./noble02/气泡框@2x.png": "f4d9",
	"./noble03/气泡框@2x.png": "ad12",
	"./noble04/气泡框@2x.png": "ca87",
	"./noble05/气泡框@2x.png": "68ed"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b8f5";